export default __webpack_public_path__ + "829139909a596ad4aa38d36bcf50bbd9.svg";